import React from 'react';
import { Formik, FormikHelpers } from 'formik';
import { MessageFormValues } from './types';
import { messageSchema } from './schemas';

type Props = {
  initialMessage?: string;
  onSubmit: (
    values: MessageFormValues,
    helpers: FormikHelpers<MessageFormValues>
  ) => void;
  children: React.ReactNode;
};

export function MessageForm({
  initialMessage = '',
  onSubmit,
  children,
}: Readonly<Props>) {
  return (
    <Formik<MessageFormValues>
      initialValues={{ message: initialMessage }}
      validationSchema={messageSchema}
      enableReinitialize
      validateOnMount
      onSubmit={onSubmit}
    >
      {children}
    </Formik>
  );
}
